import React, { useEffect } from 'react';
import { Observer } from 'mobx-react';
import { useTheme } from '@mui/material/styles';

import { useStyles } from './GradingTab.styles'

import { useExecutionsUIStore, useGradingsUIStore } from '@core/useStores';

import { ThemeProps } from '@styles/theme';
import { GradingEditor } from '../GradingEditor';
import { GradingRecap } from '../GradingRecap';
import { Button } from '@shared/components/Button';
import { CircularProgress } from '@mui/material';

export const GradingTab: React.FC = () =>{
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    const executionsUIStore = useExecutionsUIStore();
    const gradingsUIStore = useGradingsUIStore();

    useEffect(() =>{
        const loadGrading = async () =>{
            if (!executionsUIStore.selectedExecutionId) {
                gradingsUIStore.resetCurrentGrading();

                return;
            }

            if (
                gradingsUIStore.status.isDone
                && gradingsUIStore.grading.executionId === executionsUIStore.selectedExecutionId
                && (gradingsUIStore.gradingFound || gradingsUIStore.hasReviewedGrading)
            ) {
                return;
            }

            gradingsUIStore.resetCurrentGrading();
            await gradingsUIStore.loadGradings({executionIds: [executionsUIStore.selectedExecutionId]});
        }

        void loadGrading();
    }, [executionsUIStore.selectedExecutionId, gradingsUIStore])

    const onGradingEdit = () =>{
        gradingsUIStore.toggleEdit(true);
    }

    const onCancelEdit = () =>{
        if (executionsUIStore.selectedExecutionId) {
            gradingsUIStore.clearEditorDraft(executionsUIStore.selectedExecutionId);
        }
        gradingsUIStore.toggleEdit(false);
    }

    return (
        <Observer>
            {() =>{
                const showRecap = gradingsUIStore.gradingFound && gradingsUIStore.hasReviewedGrading && !gradingsUIStore.editing;

                return (
                    <div className={styles.body}>
                        {gradingsUIStore.status.isDone &&
                        <>
                            {showRecap &&
                                <>
                                    <>
                                        <GradingRecap />
                                        <div className={styles.footer}>
                                            <div className={styles.selectorControls}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className={styles.backButton}
                                                    onClick={onGradingEdit}>
                                                        Edit
                                                </Button>
                                                {/* <button className={styles.nextButton}>
                                                    Confirm
                                                </button> */}
                                            </div>
                                        </div>
                                    </>
                                </>
                                ||
                                <GradingEditor onCancel={onCancelEdit} hasGrading={gradingsUIStore.gradingFound}/>
                            }
                        </>
                        ||
                        <CircularProgress className={styles.loader} color='inherit' size={50} />

                        }
                    </div>
                )
            }}
        </Observer>
    )
}